export default {
  paged: {
    select:
      'id,status,billingMode,monthlyFee,currency,billingCycleType,paymentCollectionMode,nextBillingDate,autoRenew',
    searchSelect: ['company/commercialName', 'automyPlan/name'],
    orderBy: 'company/commercialName asc',
    expand: {
      company: {
        select: 'commercialName',
      },
      automyPlan: {
        select: 'name',
      },
    },
  },
  itemDetail: {
    expand: {
      company: {
        select: 'commercialName',
      },
      automyPlan: {
        select: 'name',
      },
      customerChannelAssignment: {
        select: 'sourceType',
      },
      billingCountry: {
        select: 'code,name',
      },
      defaultPaymentMethod: {
        select: 'methodType',
      },
    },
  },
};
